import React from 'react';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  Receipt as ReceiptIcon,
  PieChart as ChartBarIcon // Asegúrate de usar el nombre correcto según MUI
} from '@mui/icons-material';

export const getStatusIcon = (status: string) => {
  switch (status) {
    case 'paid': return <CheckCircleIcon color="success" />;
    case 'pending': return <ErrorIcon color="warning" />;
    case 'baja': return <WarningIcon color="error" />;
    case 'partial': return <ChartBarIcon color="primary" />;
    default: return <ReceiptIcon color="action" />;
  }
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'paid': return 'success';
    case 'pending': return 'warning';
    case 'partial': return 'primary';
    case 'baja': return 'error';
    case 'finalizado': return 'info';
    case 'alta': return 'secondary';
    default: return 'default';
  }
};

export const getStatusLabel = (status: string) => {
  switch (status) {
    case 'paid': return 'Pagado';
    case 'pending': return 'Pendiente';
    case 'partial': return 'Por cuotas';
    case 'baja': return 'Baja';
    case 'alta': return 'Alta';
    case 'finalizado': return 'Finalizado'; // Agregado para que esté a la par con tus colores
    default: return status; // Retorna el valor original si no coincide con ninguno
  }
};